import { inject, Injectable } from '@angular/core';
import { Query, QueryRepository } from '@okcargo/query-processor';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({ providedIn: 'root' })
export class BaseQueryRepository implements QueryRepository {
  private readonly apiService = inject(ApiService);

  private readonly _baseUrl = '/service/query-processor/api/queries';
  // constructor() {}

  execute(name: string, query: Query): Promise<any> {
    const baseUrl = this._baseUrl;
    return firstValueFrom(
      // this.apiService.get<any>(
      this.apiService.get(`${baseUrl}?name=${name}&payload=${encodeURI(JSON.stringify(query))}`, {
        observe: 'body',
      }),
    );
  }
}
